import { render, staticRenderFns } from "./DoclibSearch.vue?vue&type=template&id=2096d42a&scoped=true"
import script from "./DoclibSearch.vue?vue&type=script&lang=js"
export * from "./DoclibSearch.vue?vue&type=script&lang=js"
import style0 from "./DoclibSearch.vue?vue&type=style&index=0&id=2096d42a&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2096d42a",
  null
  
)

export default component.exports